import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import PDFIMG from "../../Config/pdf.svg";
import EXCELIMG from "../../Config/excel.svg";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../Config/loading.css";
import { Link, useNavigate } from "react-router-dom";
import { useLabelContext } from "../../../Context";
import { Footer } from "../footer/footer";

export default function Expenses() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [expensesData, setExpensesData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [locationViewObj, setLocationViewObj] = useState([]);
  const [locationEditObj, setLocationEditObj] = useState([]);
  const { setID } = useLabelContext();

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_CRM_URL}expenses/GetExpenses`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        if (data.Status) {
          setExpensesData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setExpensesData([]);
        }
      } catch (error) {
        console.error("Error fetching datasssss:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  const showLocationViewModal = (obj) => {
    setLocationViewObj(obj);
  };

  const showLocationEditModal = (obj) => {
    setLocationEditObj(obj);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  // const filteredItems = expensesData.filter(
  //   (item) =>
  //     (item.proj_name &&
  //       item.proj_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (item.category_name &&
  //       item.category_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (item.expense_name &&
  //       item.expense_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (item.cus_name &&
  //       item.cus_name.toLowerCase().includes(searchTerm.toLowerCase()))
  // );

  const filteredItems = useMemo(() => {
    const results = expensesData.filter(
      (item) =>
        (item.proj_name &&
          item.proj_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.category_name &&
          item.category_name
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (item.expense_name &&
          item.expense_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.cus_name &&
          item.cus_name.toLowerCase().includes(searchTerm.toLowerCase())),
    );

    setCurrentPage(1);

    return results;
  }, [expensesData, searchTerm]);

  // Calculate indices for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleExcelDownload = () => {
    if (expensesData.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = expensesData.map((item) => ({
      Name: item.expense_name,
      Date: formatDate(item.date),
      Category: item.category_name,
      Amount: item.amount,
      Customer: item.cus_name,
      Project: item.proj_name,
      "Payment Type": item.paymentmode,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "CustoemrsData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "CustoemrsData.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Expenses Data",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = [
      "Name",
      "Date",
      "Category",
      "Amount",
      "Customer",
      "Project",
      "Payment Type",
    ];
    tableData.push(headers);

    // Add rows
    expensesData.forEach((item) => {
      const row = [];
      row.push(
        item.expense_name,
        formatDate(item.date),
        item.category_name,
        item.amount,
        item.cus_name,
        item.proj_name,
        item.paymentmode,
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("expensesData.pdf");
  };

  const handleViewPurchaseOrders = (item) => {
    console.log(item);
    setID(item.id);
  };

  return (
    <Base>
      <div className="">
        <div className="d-flex justify-content-between py-2 mb-3">
          <div className="page-title">
            <h4>Expense</h4>
            <h6>Manage your Expenses</h6>
          </div>

          <div>
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  onClick={handlePDFDownload}
                  className="btn btn-light btn-sm px-0"
                >
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>

              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  onClick={handleExcelDownload}
                  className="btn btn-light btn-sm"
                >
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>

              <li>
                <Link
                  to="/add-expense"
                  className="btn btn-sm"
                  style={{ backgroundColor: "#1B2850" }}
                >
                  <i
                    className="fa-solid fa-plus"
                    style={{ color: "white" }}
                  ></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-12 mb-3">
          <div className="input-group">
            <input
              type="text"
              name="search"
              placeholder="Search..."
              className="form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="input-group-text bg-primary">
              <i className="fa-solid fa-magnifying-glass"></i>
            </span>
          </div>
        </div>
      </div>

      <div className="row g-2 mb-4">
        {loading ? (
          <div className="col-12 text-center">
            <div className="containers m-auto">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        ) : (
          currentItems &&
          currentItems.map((item, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4">
              <div className="card mb-0 rounded-4">
                <div className="card-body">
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-start mb-1 ">
                    <Link
                      to="/view-expense"
                      className="dropdown-item p-0"
                      state={{ ExpensesData: item }}
                    >
                      <div className="d-flex align-items-start gap-2 ">
                        <div
                          style={{
                            width: "45px",
                            height: "45px",
                            borderRadius: "50%",
                            backgroundColor: "#E3F2FD",
                            color: "#1B2850",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "bold",
                            // marginRight: "8px",
                            textTransform: "uppercase",
                          }}
                        >
                          {item?.expense_name?.trim()
                            ? item.expense_name.trim().substring(0, 2)
                            : "NA"}
                        </div>

                        <div>
                          <h6
                            className="mb-0 fw-bold"
                            style={{ color: "#1B2850" }}
                            title={item.expense_name}
                          >
                            {item.expense_name?.length > 40
                              ? item.expense_name.substring(0, 40) + "..."
                              : item.expense_name}
                          </h6>

                          <small className="text-muted">
                            {item.expense_category_name}{" "}
                          </small>
                        </div>
                      </div>
                    </Link>

                    <div className="dropdown">
                      <a
                        href="#"
                        className="text-dark"
                        data-bs-toggle="dropdown"
                        onClick={(e) => e.preventDefault()}
                      >
                        <i className="fa fa-ellipsis-v fs-5"></i>
                      </a>

                      <div className="dropdown-menu dropdown-menu-end">
                        <Link
                          to="/view-expense"
                          className="dropdown-item"
                          state={{ ExpensesData: item }}
                        >
                          <i className="fa-regular fa-eye text-primary me-2"></i>
                          View
                        </Link>

                        {/* <Link
                          to="/edit-expense"
                          className="dropdown-item"
                          onClick={() => handleViewPurchaseOrders(item)}
                          state={{ ExpensesData: item }}
                        >
                          <i className="fa-regular fa-pen-to-square text-info me-2"></i>
                          Edit
                        </Link> */}
                      </div>
                    </div>
                  </div>

                  {/* Details */}
                  <div className="card-details">
                    <div className="row g-3">
                      <div className="col-4">
                        <div className="d-flex align-items-center">
                          <i
                            className="fa-solid fa-calendar-days me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          <span>{formatDate(item.date)}</span>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="d-flex align-items-center">
                          <i
                            className="fa-solid fa-user me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          <span title={item.client_name}>
                            {item.client_name?.length > 10
                              ? item.client_name.substring(0, 10) + "..."
                              : item.client_name || "N/A"}
                          </span>
                        </div>
                      </div>

                      <div className="col-4">
                        <div className="d-flex align-items-center">
                          <i
                            className="fa-solid fa-indian-rupee-sign me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          <span>{item.amount}</span>
                        </div>
                      </div>

                      <div className="col-3">
                        <div className="d-flex align-items-center">
                          <i
                            className="fa-solid fa-credit-card me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          <span title={item.payment_mode_name}>
                            {item.payment_mode_name}
                          </span>
                        </div>
                      </div>

                      <div className="col-9">
                        <div className="d-flex align-items-center">
                          <i
                            className="fa-solid  fa-note-sticky me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          <span title={item.note}>
                            {item.note?.length > 30
                              ? item.note.substring(0, 30) + "..."
                              : item.note || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}

        <div className="col-12">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>

      <Footer></Footer>
    </Base>
  );
}
